
const paraphraseEnabledViaEnv = !!import.meta.env.VITE_PARAPHRASE_ENABLED && import.meta.env.VITE_PARAPHRASE_ENABLED !== 'false'

const urlParams = new URLSearchParams(document.location.search)

const paraphraseEnabledViaUrl = urlParams.get('paraphrase') || urlParams.get('parafrase')

const ENV = {
    PARAPHRASE_DISABLED: !paraphraseEnabledViaEnv && !paraphraseEnabledViaUrl
}
console.log('paraphraseEnabled', !paraphraseEnabledViaEnv, !paraphraseEnabledViaUrl, ENV)

export { ENV }